import {
  faBell as lightBell,
  faCalendarCheck as lightCalendarCheck,
  faClock as lightClock,
  faFloppyDisk as lightFloppyDisk,
  faFolder as lightFolder,
  faGrid2Plus as lightGrid2Plus,
  faMobile as lightMobile,
  faTriangleExclamation as lightTriangleExclamation,
} from "@awesome.me/kit-81e892e0ca/icons/classic/light";
import {
  faAngleDown as regularAngleDown,
  faAngleRight as regularAngleRight,
  faAngleUp as regularAngleUp,
  faArrowsSplitUpAndLeft as regularArrowsSplitUpAndLeft,
  faArrowDown as regularArrowDown,
  faArrowLeft as regularArrowLeft,
  faArrowRight as regularArrowRight,
  faArrowsRepeat as regularArrowsRepeat,
  faArrowsRotate as regularArrowsRotate,
  faArrowUp as regularArrowUp,
  faArrowUpRightAndArrowDownLeftFromCenter as regularArrowUpRightAndArrowDownLeftFromCenter,
  faArrowUpRightFromSquare as regularArrowUpRightFromSquare,
  faAsterisk as regularAsterisk,
  faBars as regularBars,
  faBell as regularBell,
  faBlockQuote as regularBlockQuote,
  faBold as regularBold,
  faBookmark as regularBookmark,
  faBooks as regularBooks,
  faBracketsCurly as regularBracketsCurly,
  faBuildingColumns as regularBuildingColumns,
  faCalendar as regularCalendar,
  faCalendarCheck as regularCalendarCheck,
  faCheck as regularCheck,
  faCheckCircle as regularCheckCircle,
  faChevronLeft as regularChevronLeft,
  faChevronRight as regularChevronRight,
  faCircleExclamation as regularCircleExclamation,
  faCircleInfo as regularCircleInfo,
  faCircleUser as regularCircleUser,
  faClockRotateLeft as regularClockRotateLeft,
  faComment as regularComment,
  faCommentCheck as regularCommentCheck,
  faCopy as regularCopy,
  faEnvelope as regularEnvelope,
  faFileCircleInfo as regularFileCircleInfo,
  faFilePen as regularFilePen,
  faFilter as regularFilter,
  faFolder as regularFolder,
  faGear as regularGear,
  faGlobe as regularGlobe,
  faGripDotsVertical as regularGripDotsVertical,
  faH1 as regularH1,
  faH2 as regularH2,
  faH3 as regularH3,
  faIndent as regularIndent,
  faItalic as regularItalic,
  faLink as regularLink,
  faList12 as regularList12,
  faListUl as regularListUl,
  faMagnifyingGlass as regularMagnifyingGlass,
  faMagnifyingGlassMinus as regularMagnifyingGlassMinus,
  faMessageLines as regularMessageLines,
  faMessages as regularMessages,
  faMinus as regularMinus,
  faOutdent as regularOutdent,
  faPaperPlaneTop as regularPlaneTop,
  faPencil as regularPencil,
  faPenToSquare as regularPenToSquare,
  faPlus as regularPlus,
  faPrint as regularPrint,
  faQrcode as regularQrcode,
  faRepeat as regularRepeat,
  faShare as regularShare,
  faSparkles as regularSparkles,
  faSpinner as regularSpinner,
  faStar as regularStar,
  faText as regularText,
  faTrashCan as regularTrashCan,
  faUnderline as regularUnderline,
  faWaveformLines as regularWaveformLines,
  faWindow as regularWindow,
  faXmark as regularXmark,
  faXmarkLarge as regularXmarkLarge,
} from "@awesome.me/kit-81e892e0ca/icons/classic/regular";
import {
  faArrowsSplitUpAndLeft as solidArrowsSplitUpAndLeft,
  faBell as solidBell,
  faBracketsCurly as solidBracketsCurly,
  faCalendar as solidCalendar,
  faCalendarClock as solidCalendarClock,
  faCheck as solidCheck,
  faChevronRight as solidChevronRight,
  faCircleCheck as solidCircleCheck,
  faCircleExclamation as solidCircleExclamation,
  faCircleInfo as solidCircleInfo,
  faCircleSmall as solidCircleSmall,
  faComment as solidComment,
  faCommentCheck as solidCommentCheck,
  faContactCard as solidContactCard,
  faCopy as solidCopy,
  faCreditCard as solidCreditCard,
  faDiamondExclamation as solidDiamondExclamation,
  faDollarSign as solidDollarSign,
  faEllipsis as solidEllipsis,
  faEnvelope as solidEnvelope,
  faFileArrowUp as solidFileArrowUp,
  faFileCircleInfo as solidFileCircleInfo,
  faFloppyDisk as solidFloppyDisk,
  faFolder as solidFolder,
  faGear as solidGear,
  faGlobe as solidGlobe,
  faGripDotsVertical as solidGripDotsVertical,
  faHashtag as solidHashtag,
  faH1 as solidH1,
  faH2 as solidH2,
  faH3 as solidH3,
  faIndent as solidIndent,
  faInputText as solidInputText,
  faLanguage as solidLanguage,
  faList as solidList,
  faList12 as solidList12,
  faListUl as solidListUl,
  faLink as solidLink,
  faListRadio as solidListRadio,
  faLocationDot as solidLocationDot,
  faMagnifyingGlass as solidMagnifyingGlass,
  faMemo as solidMemo,
  faMinus as solidMinus,
  faNetworkWired as solidNetworkWired,
  faObjectGroup as solidObjectGroup,
  faOutdent as solidOutdent,
  faPaperPlaneTop as solidPaperPlaneTop,
  faPencil as solidPencil,
  faPenToSquare as solidPenToSquare,
  faPhone as solidPhone,
  faPlus as solidPlus,
  faQrcode as solidQrcode,
  faSave as solidSave,
  faShare as solidShare,
  faShieldCheck as solidShieldCheck,
  faSignature as solidSignature,
  faSpinner as solidSpinner,
  faSquareA as solidSquareA,
  faSquareFull as solidSquareFull,
  faSquareUp as solidSquareUp,
  faStar as solidStar,
  faTrashCan as solidTrashCan,
  faTriangleExclamation as solidTriangleExclamation,
  faUnderline as solidUnderline,
  faUpRightFromSquare as solidUpRightFromSquare,
  faWaveformLines as solidWaveformLines,
  faXmark as solidXmark,
  faXmarkLarge as solidXmarkLarge,
} from "@awesome.me/kit-81e892e0ca/icons/classic/solid";

export const availableIcons = {
  lightBell,
  lightCalendarCheck,
  lightClock,
  lightFloppyDisk,
  lightFolder,
  lightGrid2Plus,
  lightMobile,
  lightTriangleExclamation,
  regularAngleDown,
  regularAngleRight,
  regularAngleUp,
  regularArrowsSplitUpAndLeft,
  regularArrowDown,
  regularArrowLeft,
  regularArrowRight,
  regularArrowsRepeat,
  regularArrowsRotate,
  regularArrowUp,
  regularArrowUpRightAndArrowDownLeftFromCenter,
  regularArrowUpRightFromSquare,
  regularAsterisk,
  regularBars,
  regularBell,
  regularBlockQuote,
  regularBold,
  regularBookmark,
  regularBooks,
  regularBracketsCurly,
  regularBuildingColumns,
  regularCalendar,
  regularCalendarCheck,
  regularCheck,
  regularCheckCircle,
  regularChevronLeft,
  regularChevronRight,
  regularCircleExclamation,
  regularCircleInfo,
  regularCircleUser,
  regularClockRotateLeft,
  regularComment,
  regularCommentCheck,
  regularCopy,
  regularEnvelope,
  regularFileCircleInfo,
  regularFilePen,
  regularFilter,
  regularFolder,
  regularGear,
  regularGlobe,
  regularGripDotsVertical,
  regularH1,
  regularH2,
  regularH3,
  regularIndent,
  regularItalic,
  regularLink,
  regularList12,
  regularListUl,
  regularMagnifyingGlass,
  regularMagnifyingGlassMinus,
  regularMessageLines,
  regularMessages,
  regularMinus,
  regularOutdent,
  regularPencil,
  regularPenToSquare,
  regularPlaneTop,
  regularPlus,
  regularPrint,
  regularQrcode,
  regularRepeat,
  regularShare,
  regularSparkles,
  regularSpinner,
  regularStar,
  regularText,
  regularTrashCan,
  regularUnderline,
  regularWaveformLines,
  regularWindow,
  regularXmark,
  regularXmarkLarge,
  solidArrowsSplitUpAndLeft,
  solidBell,
  solidBracketsCurly,
  solidCalendar,
  solidCalendarClock,
  solidCheck,
  solidChevronRight,
  solidCircleCheck,
  solidCircleExclamation,
  solidCircleInfo,
  solidCircleSmall,
  solidComment,
  solidCommentCheck,
  solidContactCard,
  solidCopy,
  solidCreditCard,
  solidDiamondExclamation,
  solidDollarSign,
  solidEllipsis,
  solidEnvelope,
  solidFileArrowUp,
  solidFileCircleInfo,
  solidFloppyDisk,
  solidFolder,
  solidGear,
  solidGlobe,
  solidGripDotsVertical,
  solidHashtag,
  solidH1,
  solidH2,
  solidH3,
  solidIndent,
  solidInputText,
  solidLanguage,
  solidLink,
  solidList,
  solidList12,
  solidListUl,
  solidListRadio,
  solidLocationDot,
  solidMagnifyingGlass,
  solidMemo,
  solidMinus,
  solidNetworkWired,
  solidObjectGroup,
  solidOutdent,
  solidPaperPlaneTop,
  solidPencil,
  solidPenToSquare,
  solidPhone,
  solidPlus,
  solidQrcode,
  solidSave,
  solidShare,
  solidShieldCheck,
  solidSignature,
  solidSpinner,
  solidSquareA,
  solidSquareFull,
  solidSquareUp,
  solidStar,
  solidTrashCan,
  solidTriangleExclamation,
  solidUnderline,
  solidUpRightFromSquare,
  solidWaveformLines,
  solidXmark,
  solidXmarkLarge,
};

export type IconName = keyof typeof availableIcons | "archie";
